// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../../engine/api/http";
import { roles } from "../../../utils/constants";

const initialState = {
  bills: [],
  institutionsFilter: {
    unique: [],
    multiple: [],
  },
  languagesFilter: {
    unique: [],
    multiple: [],
  },
  countType: {
    unique: 0,
    multiple: 0,
    external: 0,
  },
  loading: false,
  pagination: {
    totalDocuments: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 10,
    sorter: undefined,
  },
};

export const getBilling = createAsyncThunk(
  "posts/getBilling",
  async ({ search = "", key }, thunkAPI) => {
    const res = await http.get(`/bills?${search}`);
    return { ...res.data, key };
  },
);

export const getUniqueInstitutionsBills = createAsyncThunk(
  "bills/getUniqueInstitutionsBills",
  async (billId, thunkAPI) => {
    const res = await http.get("/bills/institutions");
    return res.data;
  },
);

export const getCountType = createAsyncThunk(
  "bills/types",
  async (year, thunkAPI) => {
    const res = await http.get("/bills/types?year=" + year);
    return res.data;
  },
);

export const getUniqueLanguagesInBills = createAsyncThunk(
  "bills/getUniqueLanguagesInBills",
  async (billId, thunkAPI) => {
    const res = await http.get("/bills/languages");
    return res.data;
  },
);

const billingSlice = createSlice({
  name: "billing",
  initialState,
  reducers: {
    setPagination: (state, { payload }) => {
      state.pagination = { ...state.pagination, ...payload };
    },
    updateBillsDocumentDates: (state, { payload }) => {
      const updates = payload || [];

      state.bills = state.bills.map(bill => {
        const update = updates.find(entry =>
          entry.billIds.includes(bill._id),
        );

        if (!update) {
          return bill;
        }

        return {
          ...bill,
          exportedDate: update.documentDate,
        };
      });
    },
    clearBilling: state => {
      return initialState;
    },
    clearBills: state => {
      state.bills = [];
    },
  },
  extraReducers: {
    [getBilling.pending]: state => {
      state.loading = true;
    },
    [getBilling.fulfilled]: (state, { payload }) => {
      state.loading = false;

      const { totalDocuments, totalPages, currentPage, pageSize } = payload;

      state.countType.external = payload.external;
      state.countType.multiple = payload.multiple;
      state.countType.unique = payload.unique;

      state.pagination.totalDocuments = totalDocuments;
      state.pagination.totalPages = totalPages;
      // state.pagination.currentPage = currentPage;
      // state.pagination.pageSize = pageSize;
      state.bills = payload.bills.sort((a, b) => {
        return a.bill_number - b.bill_number;
      });
    },
    [getUniqueInstitutionsBills.pending]: state => {
      state.loading = true;
    },
    [getUniqueInstitutionsBills.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.institutionsFilter = payload;
    },
    [getCountType.fulfilled]: (state, { payload }) => {
      state.countType = payload;
    },
    [getUniqueLanguagesInBills.pending]: state => {
      state.loading = true;
    },
    [getUniqueLanguagesInBills.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.languagesFilter = payload;
    },
    [getBilling.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export const { clearBilling, clearBills, setPagination, updateBillsDocumentDates } =
  billingSlice.actions;

export const billingReducer = billingSlice.reducer;
